import { useState, useEffect } from 'react';

export function use90s() {
  const [is90s, setIs90s] = useState(() => document.body.getAttribute('data-theme') === '90s');
  useEffect(() => {
    const obs = new MutationObserver(() => {
      setIs90s(document.body.getAttribute('data-theme') === '90s');
    });
    obs.observe(document.body, { attributes: true, attributeFilter: ['data-theme'] });
    return () => obs.disconnect();
  }, []);
  return is90s;
}
